<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">

            <div class="row" v-if="hasSessionsRight && hasPilotRight">
                <div class="col-lg-7">
                    <sessions></sessions>
                </div>
                <div class="col-lg-5">
                    <logs></logs>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-lg-12" v-if="hasSessionsRight">
                    <sessions></sessions>
                </div>
                <div class="col-lg-12" v-if="hasPilotRight">
                    <logs></logs>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <pwa-info></pwa-info>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
    import Logs from './offline/Logs';
    import Sessions from './offline/Sessions';
    import PwaInfo from './offline/PwaInfo';

    export default {

        components: {
            Logs, Sessions, PwaInfo
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('pwa.dashboard'),
                    },
                ]
            },

            hasSessionsRight() {
                return this.$auth.user.admin || this.$auth.hasPermission('dashboard.access-instructor-dashboard')
            },

            hasPilotRight() {
                return this.$auth.user.admin || this.$auth.hasPermission('dashboard.access-pilot-dashboard')
            },
        },

        created() {
            this.$loader.hide()
        },
    }
</script>
